<template>
  <div id="Home">
    <!-- <div class="hotColumn">
      <div class="hot_left">
        <ul class="hotad">
          <li>
            <img
              @click="handleLinkSite(bannerList[3])"
              v-if="bannerList[3]"
              :src="qiniuUrl+bannerList[3].imgUrl"
            />
          </li>
          <li>
            <img
              @click="handleLinkSite(bannerList[4])"
              v-if="bannerList[4]"
              :src="qiniuUrl+bannerList[4].imgUrl"
            />
          </li>
        </ul>
        <ul class="hotgames">
          <li
            v-for="(it,i) in hotGame"
            :class="{'mobile':device=='mobile'}"
            :key="i"
            v-if="i<8"
            @click="goto(it)"
          >
            <img v-lazy="{src:qiniuUrl+it.netImgUrl}" />
            <p>{{it.memo}}</p>
          </li>
        </ul>
      </div>
      <div class="hot_right" v-if="device=='desktop'">
        <img
          @click="handleLinkSite(bannerList[5])"
          v-if="bannerList[5]"
          :src="qiniuUrl+bannerList[5].imgUrl"
        />
      </div>
    </div>
    <div class="longad">
      <img
        @click="handleLinkSite(bannerList[6])"
        v-if="bannerList[6]"
        :src="qiniuUrl+bannerList[6].imgUrl"
      />
    </div> -->
    <div class="main">
      <div class="main_left">
        <GameCell
          class="left_list"
          v-for="(it,i) in indexGame"
          :key="i"
          :dataSource="it"
          @needGetData="handleGetData"
        ></GameCell>
      </div>
      <!-- <div class="main_right" v-if="device=='desktop'">
        <img
          class="advertising"
          @click="handleLinkSite(bannerList[7])"
          v-if="bannerList[7]"
          :src="qiniuUrl+bannerList[7].imgUrl"
        />
        <div class="toolbar">
          <p class="title">分析工具</p>
          <ul class="list">
            <li v-for="(it,i) in hotGame" :key="i" v-if="i<3">
              <div class="name">
                <img @click="goto(it)" class="fx_img" v-lazy="{src:qiniuUrl+it.netImgUrl}" />

                <span>{{it.memo}}</span>
              </div>
              <div class="more">
                <p>
                  <i></i>走势
                </p>
                <span @click="goto(it)">更多</span>
              </div>
              <div class="con">
                <span
                  v-for="(item,j) in menus[it.type].slice(0,3)"
                  :key="j"
                  @click="fxGoto(it,item.alias)"
                >{{item.name}}</span>
              </div>
            </li>
          </ul>
        </div>
        <img
          class="advertising"
          @click="handleLinkSite(bannerList[8])"
          v-if="bannerList[8]"
          :src="qiniuUrl+bannerList[8].imgUrl"
        />
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { formatSeconds } from '../../helpers/util.js';
import GameCell from './GameCell';
import menus from '../../helpers/trendMenus.js';

export default {
  name: 'Home',
  components: {
    GameCell
  },
  data() {
    return {
      delay: null,
      menus
    };
  },
  beforeCreate() {
    let browser = {
      versions: (function() {
        let u = window.navigator.userAgent;
        return {
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
          iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者安卓QQ浏览器
          weixin: u.indexOf('MicroMessenger') > -1, //是否为微信浏览器
          qq: u.match(/\sQQ/i) !== null //是否QQ
        };
      })()
    };
    if (browser.versions.mobile == true) {
      this.$router.push('/mobile');
    }
  },
  created() {},
  destroyed() {
    clearTimeout(this.delay);
  },
  computed: {
    ...mapState(['hotGame', 'indexGame', 'allGame', 'device', 'bannerList', 'qiniuUrl'])
  },
  methods: {
    handleGetData(gameType) {
      if (this.delay == null) {
        this.delay = setTimeout(() => {
          this.delay = null;
          this.getData();
        }, 5000);
      }
    },
    async getData() {
      this.$store.dispatch('indexPageInfo');
    },
    goto(it) {
      this.$router.push(`/Trend/${it.type}/${it.gameType}`);
    },
    fxGoto(it, item) {
      this.$router.push(`/Trend/${it.type}/${it.gameType}${item ? '?modeType=' + item : ''}`);
    },
    handleLinkSite(data) {
      if (data.isTurn == 1) {
        window.open(data.url, '_blank');
      } else {
        return;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('./index.less');
@media screen and (max-width: 1200px) {
  #Home {
    .hot_left {
      width: 100% !important;
      margin-right: 0px !important;
    }

    .main_left {
      width: 100% !important;
      // padding: 0 2%;
    }
    .left_list:nth-child(2n + 1) {
      margin-right: 4%;
    }
    .left_list:nth-child(2n) {
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue